import { useEffect, useState } from "react";
import './Ecart.css';
import { IMAGE_URL } from "../../Utils/constant";
import NO_IMAGE from "../../Assets/no_img.jpg";
const Carousel = ({ images, alt, height = "250px", width = "250px" }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleDotClick = (index) => {
    setCurrentIndex(index);
  };

  // Auto-rotate logic
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prevIndex =>
        (prevIndex + 1) % images.length
      );
    }, 3000); // rotate every 3 seconds

    return () => clearInterval(interval); // cleanup on unmount
  }, [images.length]);

  return (
    <div className="carousel">
      {
        (Array.isArray(images) &&
          images.length > 0) ?
          <div className="carousel-image-container" style={{ height: height, width: width }}>
            <img
              src={`${IMAGE_URL}${images[currentIndex]}`}
              alt={`${alt}-img-${currentIndex}`}
              className="carousel-image magnify-on-hover"
              style={{ height: height, width: width }}
            />
          </div> :
          <img src={NO_IMAGE} alt="No Image" style={{ height: height, width: width }} />
      }
      {
        (Array.isArray(images) &&
          images.length > 0) &&
        <div className="carousel-dots">
          {images.map((_, index) => (
            <span
              key={index}
              className={`dot ${index === currentIndex ? "active" : ""}`}
              onClick={() => handleDotClick(index)}
            />
          ))}
        </div>
      }
    </div>
  );
};

export default Carousel
